import { useCallback } from "react";
import { useModal } from ".";

export function useConfirmBeforeRun<T>({
  fn,
  message,
  loading = false,
}: {
  fn: (args: T) => Promise<any>;
  message: React.ReactNode;
  loading?: boolean;
}) {
  const { showModal, closeModal } = useModal();

  const handleClick = useCallback(
    (args: T) => {
      showModal({
        message,
        actions: [
          { autoFocus: true, text: "Cancel", type: "inverse", action: closeModal },
          {
            text: "Confirm",
            type: "primary",
            loading,
            action: async () => {
              await fn(args);
              closeModal();
            },
          },
        ],
      });
    },
    [showModal, message, fn, closeModal, loading]
  );

  return handleClick;
}
